import React, {useContext, useEffect, useState} from 'react';
import {NavLink, useLocation} from "react-router-dom";
import GenerateURL from "../../utils/generateURL";
import {
    ABOUT_ROUTE, API_GAMES_URL,
    CONTACTS_ROUTE,
    LOTTERY_ROUTE,
    ONLINE_SOLUTION_ROUTE,
    SOLUTION_CASINO_ROUTE, SLOT_MACHINES_ROUTE
} from "../../utils/consts";
import {useTranslation} from "react-i18next";
import {observer} from "mobx-react-lite";
import {ScrollToPositionFixed} from "../../utils/ScrollToPositionFixed";
import {useFetching} from "../../hooks/useFetching";
import ApiGamesUrl from "../../services/GamesUrl";
import device from 'current-device'
import {default_language} from "../../utils/lang";
import cookie from "js-cookie";
import {MobileMenuContext} from "../../App";

const Menu = ({separator}) => {
    const {t} = useTranslation();
    const location = useLocation();
    const [, setMobileMenu] = useContext(MobileMenuContext);

    const [urlGames, setUrlGames] = useState('');
    // const [urlGames, setUrlGames] = useState('https://www.championstudio.net/ru/?lang=ru');

    const [FunctionApiGamesUrl] = useFetching(async () => {
        const response = await ApiGamesUrl.getApiGamesUrl(API_GAMES_URL);
        setUrlGames(response.data.url);
    });

    useEffect(() => {
        FunctionApiGamesUrl();
    }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <ul className="menu">
            <li>
                <NavLink
                    to={GenerateURL(SLOT_MACHINES_ROUTE)}
                    exact
                    onClick={() => {
                        ScrollToPositionFixed(true);
                        setMobileMenu(false);
                    }}
                >{t('Ігрові автомати')}
                </NavLink>
            </li>
            <li>
                <NavLink
                    to={GenerateURL(SOLUTION_CASINO_ROUTE)}
                    exact
                    onClick={() => {
                        ScrollToPositionFixed(true);
                        setMobileMenu(false);
                    }}
                >{t('Рішення для казино')}
                </NavLink>
            </li>
            {/*{default_language === cookie.get('i18next') && <li>*/}
            {/*    <NavLink*/}
            {/*        to={GenerateURL(ONLINE_SOLUTION_ROUTE)}*/}
            {/*        exact*/}
            {/*        onClick={() => {*/}
            {/*            ScrollToPositionFixed(true);*/}
            {/*            setMobileMenu(false);*/}
            {/*        }}*/}
            {/*    >{t('Онлайн рішення')}*/}
            {/*    </NavLink>*/}
            {/*</li>}*/}
            <li>
                <NavLink
                    to={GenerateURL(LOTTERY_ROUTE)}
                    exact
                    onClick={() => {
                        ScrollToPositionFixed(true);
                        setMobileMenu(false);
                    }}
                >{t('Лотереї')}
                </NavLink>
            </li>
            <li><a href={urlGames}>{t('Ігри')}</a></li>
            {device.desktop() && separator && <li className='separator'><span /></li>}
            <li>
                <NavLink
                    to={GenerateURL(ABOUT_ROUTE)}
                    exact
                    onClick={() => {
                        ScrollToPositionFixed(true);
                        setMobileMenu(false);
                    }}
                >{t('Про нас')}
                </NavLink>
            </li>
            <li>
                <NavLink
                    to={GenerateURL(CONTACTS_ROUTE)}
                    exact
                    className="border_link"
                    onClick={() => {
                        ScrollToPositionFixed(true);
                        setMobileMenu(false);
                    }}
                >{t('Зворотний зв\'язок')}
                </NavLink>
            </li>
        </ul>
    );
};

export default observer(Menu);